import DegitalBookList from '../../views/search/DegitalBookList.vue';
import DegitalBookTile from '../../views/search/DegitalBookTile.vue';
import SearchPlus from '../../views/search/Plus.vue';
import Recommend from '../../components/Recommend.vue';
import RecommendTalents from '../../views/talent/RecommendTalents.vue';

// 検索結果表示画面
window.Vue.component('degital-book-list', DegitalBookList);
window.Vue.component('degital-book-tile', DegitalBookTile);
window.Vue.component('search-plus', SearchPlus);
// 週プレデジタル版swiper
window.Vue.component('recommend', Recommend);
// おすすめモデル
window.Vue.component('recommend-talents', RecommendTalents);
